export default __webpack_public_path__ + "static/media/img-brand-health.0fca8b73.svg";